import InlinePopover from '@/components/InlinePopover';

/**
 * ChipTip — phone-friendly click popover for badge pills that only
 * had hover `title` text before. Shows the same explainer text on
 * click, plus an optional "Open TICKER →" action at the bottom that
 * opens the Stock Modal in place (no navigation, no reload).
 *
 * Round 105c (Jun 2026) — watchlist strips (Unusual Activity,
 * Recent Hikes/Cuts, Ex-Div This Week) + snapshot pills.
 */
export default function ChipTip({ text, children, ticker, onOpenTicker, testId, className = '' }) {
  return (
    <InlinePopover
      className={className}
      testId={testId}
      title={text}
      maxWidth={280}
      render={({ close }) => (
        <div className="text-left">
          <p className="text-[11px] leading-snug text-foreground/90">{text}</p>
          {ticker && onOpenTicker && (
            <button
              type="button"
              className="mt-2 inline-flex items-center gap-1 text-[11px] font-bold text-sky-600 dark:text-sky-400 hover:underline underline-offset-2"
              onClick={() => { close(); onOpenTicker(ticker); }}
              data-testid={testId ? `${testId}-open` : undefined}
            >
              Open {ticker} →
            </button>
          )}
        </div>
      )}
    >
      {children}
    </InlinePopover>
  );
}
